export default "__VITE_ASSET__C$DDwKZY__ 720w";